module.exports = __webpack_public_path__ + "img/manage07.e361c68f.png";